import type { MutationHookOptions } from '@apollo/client'
import {
  TrainingClassesDocument,
  TrainingSessionsDocument,
  TrainingSessionsFiltersDocument,
  UpdateTrainingsSessionDocument,
  UpdateTrainingsSessionMutation,
  UpdateTrainingsSessionMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  UpdateTrainingsSessionMutation,
  UpdateTrainingsSessionMutationVariables
>

export const useUpdateSession = (options?: Options) => {
  const [updateSession, { loading }] = useMutation(UpdateTrainingsSessionDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.updateTrainingsSession,
  })

  return {
    loading,
    update(variables: UpdateTrainingsSessionMutationVariables) {
      return updateSession({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          TrainingClassesDocument,
          TrainingSessionsDocument,
          TrainingSessionsFiltersDocument,
        ],
      })
    },
  }
}
